export interface DashboardFilterOption {
    key: string | number | null;
    value: string;
    valueKey?: string;
    count?: number;
    available?: boolean;
}

export interface DashboardFilterConfig {
    key: string;
    labelKey: string;
    group: 'main' | 'utm';
    /** Defaults to true when omitted. */
    multiSelect?: boolean;
    allLabelKey?: string;
    /** API response field that holds this filter's options. */
    optionsKey?: string;
    /** Used when options are not loaded from the API (e.g. tracked/untracked). */
    staticOptions?: DashboardFilterOption[];
}

/** API returns null for notifications without rede_ads_id; we use 0 in filters/query params. */
export const NO_REDE_ADS_FILTER_ID = 0;

export function isMultiSelectFilter(config: DashboardFilterConfig): boolean {
    return config.multiSelect !== false;
}

export function normalizeDashboardFilterKey(
    key: string | number | null,
    configKey: string,
    numberFilterKeys: ReadonlySet<string>,
): string | number | null {
    if (key === null || key === undefined || key === '') {
        return configKey === 'rede_ads_id' ? NO_REDE_ADS_FILTER_ID : null;
    }

    if (!numberFilterKeys.has(configKey)) {
        return String(key);
    }

    const asNumber = Number(key);
    return Number.isNaN(asNumber) ? null : asNumber;
}

export function resolveDashboardFilterOptions(
    config: DashboardFilterConfig,
    filtrosOptions: object | null,
): DashboardFilterOption[] {
    if (config.staticOptions?.length) {
        return config.staticOptions;
    }

    if (!filtrosOptions || !config.optionsKey) {
        return [];
    }

    const options = (filtrosOptions as Record<string, DashboardFilterOption[] | undefined>)[config.optionsKey];
    if (!options) {
        return [];
    }

    if (config.optionsKey === 'rede_ads') {
        return options.map((option) => ({
            ...option,
            key: option.key == null ? NO_REDE_ADS_FILTER_ID : option.key,
        }));
    }

    return options;
}

export function isDashboardFilterOptionAvailable(option: DashboardFilterOption): boolean {
    return option.available !== false;
}

export function withRedeAdsDashboardFilterAvailability(
    options: DashboardFilterOption[],
    isRedeAdsAtiva: (redeAdsId: number | null | undefined) => boolean,
): DashboardFilterOption[] {
    return options.map((option) => {
        if (option.key == null || Number(option.key) === NO_REDE_ADS_FILTER_ID) {
            return { ...option, available: true };
        }

        return {
            ...option,
            available: isRedeAdsAtiva(Number(option.key)),
        };
    });
}
